(() => {
  const { accountId, livePlayerId, vodPlayerId } =
    (window.tv2 && window.tv2.brightcove) || {};

  if (!accountId && (!livePlayerId || !vodPlayerId)) {
    console.error('missing configuration for the brightcove player', {
      accountId,
      livePlayerId,
      vodPlayerId,
    });

    return;
  }

  const videoElements = Array.prototype.slice.apply(
    window.document.querySelectorAll('.tc_video__video'),
  );

  if (videoElements.length) {
    videoElements.forEach((elem) => {
      // prevent loading this when video is running in react
      // sometimes content can be mixed
      if (elem.getAttribute('data-vanilla') === 'false') {
        return;
      }

      const videoJsElem = elem.querySelector('video, video-js');
      const live = elem.getAttribute('data-live') === 'true';
      videoJsElem.setAttribute('data-account', accountId);
      const playerId = live ? livePlayerId : vodPlayerId;
      videoJsElem.setAttribute('data-player', playerId);
      const scriptPath = `https://players.brightcove.net/${accountId}/${playerId}_default/index.min.js`;
      window.tv2.utils.loadScript(scriptPath, () => {
        const player = bc(videoJsElem);
        window.tv2messages.publish('brightcoveplayer.ready', player);
      });

      const closeButton = elem.querySelector('.tc_video__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          elem.classList.add('tc_video__video--hide');
        });
      }
    });
  }
})();
